import { __assign } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { httpDelete } from '@office-start/xhr-service';
import { logUploadFeature } from '../utilities/logUploadFeature';
export function cancelUploadSession(graphXhrOptions, sessionUrl, sessionId) {
    return httpDelete(KnownInstrumentationEvents.OneDriveGraphCancelUploadSessionRequest, "OneDrive_Graph_Cancel_Upload_Session" /* KnownRequestInstrumentationEvents.OneDriveGraphCancelUploadSessionRequest */, sessionUrl, {}, {}, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
        populateRequestEvent: function (response, params) {
            var otelParams = __assign({}, params);
            logUploadFeature("OneDrive_Graph_Cancel_Upload_Session" /* KnownRequestInstrumentationEvents.OneDriveGraphCancelUploadSessionRequest */, sessionId, response, otelParams);
        },
    }).catch(function (error) {
        getErrorHandler().handleError(error, "wQvvW" /* ErrorId.wQvvW */);
        throw error;
    });
}
//# sourceMappingURL=cancelUploadSession.js.map